import { Component, ElementRef, HostListener, ViewChild, input, signal, effect, OnInit, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OtherOffers } from 'src/app/products/models/product.model';
import { DRAWING_INSTRUCTION } from 'src/app/shared/svg-util/svg-path';
import { CashPointSvgComponent } from "src/app/components/cash-point-svg/cash-point-svg.component";
import { MathFloorPipe } from 'src/app/shared/pipes/math-floor.pipe';
import { SafeHtmlPipe } from 'src/app/shared/pipes/safe-html.pipe';
import { DeviceDetectionService } from 'src/app/core/services/device-detection/device-detection.service';

@Component({
  standalone: true,
  selector: 'base-product-available-offers',
  templateUrl: './product-available-offers.component.html',
  styleUrls: ['./product-available-offers.component.scss'],
  imports: [
    CommonModule,
    CashPointSvgComponent,
    MathFloorPipe,
    SafeHtmlPipe
  ]
})

export class ProductAvailableOffersComponent implements OnInit {
  private readonly deviceDetectionService = inject(DeviceDetectionService);

  DRAWING_INSTRUCTION = DRAWING_INSTRUCTION;
  @ViewChild('termsContainer') termsContainer!: ElementRef;


  isExpanded = false;
  isOpenTermsCondition = false;
  activeOfferIndex = -1;
  viewMore = false;

  // Use computed signal instead of effect for better performance
  readonly MAX_OFFERS_TO_SHOW = computed(() => {
    const isMobile = this.deviceDetectionService.isMobile();
    return isMobile ? 2 : 3;
  });



  readonly availableOffersInput = input<OtherOffers[]>([]);
  private _availableOffersSignal = signal<OtherOffers[]>([]);

  get availableOffers(): OtherOffers[] {
    if (this.isExpanded) {
      return [...this._availableOffersSignal()]
    } else {
      return this._availableOffersSignal().slice(0, this.MAX_OFFERS_TO_SHOW())
    }
  }

  @HostListener('document:click', ['$event']) onClickOutside(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;
    if (this.isOpenTermsCondition && this.termsContainer) {
      // If click inside termsContainer, do nothing
      const clickedInside = this.termsContainer?.nativeElement.contains(clickedElement);

      if (!clickedInside && !clickedElement.classList.contains('det-text-available-offers-tc')) {
        // if clicked outside AND not clicking on "T&C" button itself
        this.openTermsCondition(-1, false);
      }
    }
  }

  constructor() {
    effect(() => {
      const availableOffersValue = this.availableOffersInput();
      this._availableOffersSignal.set(availableOffersValue ?? []);
      availableOffersValue.length > this.MAX_OFFERS_TO_SHOW() ? this.viewMore = true : this.viewMore = false;
    });
  }

  ngOnInit(): void {
  }

  toggleViewMoreOffers(event?: MouseEvent) {
    event?.stopPropagation();
    this.isExpanded = !this.isExpanded;
  }


  openTermsCondition(index: number, isActive: boolean) {
    this.activeOfferIndex = index;
    this.isOpenTermsCondition = isActive;
  }

}

